export const dotConfig = {
    fill: 'black',
    radius: 3,
}
